import {ErrorResponseCode} from './error-response';

export interface CustomErrorOptionalParams {
  tags?: string[];
  code?: ErrorResponseCode;
  codes?: ErrorResponseCode[];
}

export class CustomError extends Error {
  readonly tags?: string[];
  readonly code?: ErrorResponseCode;
  readonly codes?: ErrorResponseCode[];

  constructor(message: string, params?: CustomErrorOptionalParams) {
    super(message);
    this.tags = params?.tags;
    this.code = params?.code;
    this.codes = params?.codes;
  }
}
